// extracted by mini-css-extract-plugin
export var active = "_g5-7";
export var blink = "_g5-8";
export var dropDownSelector = "_g5-4";
export var dropDownWrapper = "_g5-3";
export var fakeCursor = "_g5-6";
export var fontSizeButton = "_g5-9";
export var formQuillEditor = "_g5-0";
export var pressed = "_g5-a";
export var qlBlank = "_g5-1";
export var textFormattingToolbar = "_g5-2";
export var textToolbarOption = "_g5-5";